/** Internal type. DO NOT USE DIRECTLY. */
type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
/** Internal type. DO NOT USE DIRECTLY. */
export type Incremental<T> = T | { [P in keyof T]?: P extends ' $fragmentName' | '__typename' ? T[P] : never };
import * as Types from '~/common/types/graphql.ts';

import { TypedDocumentNode as DocumentNode } from '@graphql-typed-document-node/core';
export type DataSourceGSheetsClaspPushInput = {
  id: string;
  tenantId: string;
};

export type ClaspPushDataSourceGSheetsMutationVariables = Exact<{
  input: Types.DataSourceGSheetsClaspPushInput;
}>;


export type ClaspPushDataSourceGSheetsMutation = { cnutClaspPushDataSourceGSheets: { __typename: 'DataSourceGSheetsClaspPushOutput', id: string } };


export const ClaspPushDataSourceGSheetsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"ClaspPushDataSourceGSheets"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"DataSourceGSheetsClaspPushInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"cnutClaspPushDataSourceGSheets"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]} as unknown as DocumentNode<ClaspPushDataSourceGSheetsMutation, ClaspPushDataSourceGSheetsMutationVariables>;